"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.list.title': 'Sesiones de Onboarding',
    'onboarding.list.empty': 'No se encontraron sesiones de onboarding',
    'onboarding.list.description': 'Gestione los procesos de onboarding para los miembros de su equipo.',
    'onboarding.list.records': 'Registros de Onboarding',
};
